module.exports = __webpack_public_path__ + "0c209b7b6d2e51eb4af3ffed14d42cfc.pdf";